module.exports = __webpack_public_path__ + "assets/media/day31.06856902.mp3";